// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RIN9","colBig":"styles_colBig__3qkX0","colSmall":"styles_colSmall__3r_DY"};